import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const MAP_STYLES = {
  clean: {
    name: 'Clean',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, HERE, Garmin, &copy; OpenStreetMap contributors'
  }
};

const EuropeMap = ({ cities, selectedCities, onCitySelect, highlightedCities, disabled = false }) => {
  const [mapStyle, setMapStyle] = useState('clean');
  const mapCenter = [54.5260, 15.2551]; // Center of Europe
  const mapZoom = 4;

  const createCustomIcon = (cityName, isSelected, isHighlighted) => {
    let backgroundColor = '#94a3b8'; // gray for non-highlighted cities

    if (isHighlighted) {
      // Highlighted cities should be green (or red if also selected when enabled)
      backgroundColor = (!disabled && isSelected) ? '#ef4444' : '#10b981';
    } else if (!disabled && isSelected) {
      // Only show red for selected when not disabled
      backgroundColor = '#ef4444';
    } else if (disabled) {
      // Non-highlighted cities when disabled
      backgroundColor = '#d1d5db';
    }

    return L.divIcon({
      className: 'custom-marker',
      html: `<div style="
        width: ${isHighlighted ? '24px' : '20px'};
        height: ${isHighlighted ? '24px' : '20px'};
        border-radius: 50%;
        background-color: ${backgroundColor};
        border: 2px solid white;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
        cursor: ${disabled ? 'default' : 'pointer'};
        transition: all 0.3s ease;
        opacity: ${disabled && !isHighlighted ? '0.6' : '1'};
      "></div>`,
      iconSize: [isHighlighted ? 24 : 20, isHighlighted ? 24 : 20],
      iconAnchor: [isHighlighted ? 12 : 10, isHighlighted ? 12 : 10]
    });
  };

  const currentStyle = MAP_STYLES[mapStyle] || MAP_STYLES.clean;

  return (
    <div>
{/*       Coming Soon Banner
      {disabled && (
        <div className="mb-3 p-3 rounded-lg border-2 border-blue-400 bg-blue-50 text-blue-800">
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-semibold">City selection and custom simulations coming soon!</span>
          </div>
        </div>
      )} */}

      <div className="h-96 w-full border-2 rounded-lg overflow-hidden" style={{ borderColor: '#E78E42' }}>
        <MapContainer
          center={mapCenter}
          zoom={mapZoom}
          minZoom={3}
          maxZoom={6}
          style={{ height: '100%', width: '100%' }}
          key={mapStyle}
        >
          <TileLayer
            attribution={currentStyle.attribution}
            url={currentStyle.url}
          />
        {Object.entries(cities).map(([cityName, cityData]) => {
          const isSelected = selectedCities.includes(cityName);
          const isHighlighted = highlightedCities && highlightedCities.includes(cityName);

          return (
            <Marker
              key={cityName}
              position={[cityData.lat, cityData.lng]}
              icon={createCustomIcon(cityName, isSelected, isHighlighted)}
              eventHandlers={{
                click: () => !disabled && onCitySelect(cityName)
              }}
            >
{/*               <Popup>
                <div className="text-center">
                  <strong>{cityName}</strong>
                  <br />
                  {cityData.country}
                  {isHighlighted && (
                    <>
                      <br />
                      <span className="text-xs text-green-600 font-semibold">
                        Used in selected case
                      </span>
                    </>
                  )}
                  <br />
                  {disabled ? (
                    <div className="mt-2 px-3 py-1 rounded text-sm bg-gray-300 text-gray-600">
                      Coming Soon
                    </div>
                  ) : (
                    <button
                      className={`mt-2 px-3 py-1 rounded text-sm ${
                        selectedCities.includes(cityName)
                          ? 'bg-red-500 text-white'
                          : 'bg-blue-500 text-white'
                      }`}
                      onClick={() => onCitySelect(cityName)}
                    >
                      {selectedCities.includes(cityName) ? 'Remove' : 'Select'}
                    </button>
                  )}
                </div>
              </Popup> */}
            </Marker>
          );
        })}
        </MapContainer>
      </div>

      {/* Legend */}
      <div className="mt-3 p-3 rounded-lg border-2" style={{ backgroundImage: 'linear-gradient(to right, rgba(231, 142, 66, 0.05), rgba(234, 193, 68, 0.05))', borderColor: '#E78E42' }}>
        <div className="text-xs font-semibold mb-2" style={{ color: '#000755' }}>Legend:</div>
        <div className="grid grid-cols-2 gap-2 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-green-500 border-2 border-white"></div>
            <span>Used in selected case</span>
          </div>
          {!disabled && (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full bg-red-500 border-2 border-white"></div>
              <span>User selected</span>
            </div>
          )}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-gray-400 border-2 border-white"></div>
            <span>Not used</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EuropeMap;